// @flow
import type {Element, Node} from 'react'
import React from 'react'
import {ReactRelayContext} from 'react-relay'
import {Popover, PopoverHeader, PopoverBody} from 'reactstrap'
import classNames from 'classnames'

import {useToggle} from 'utils/hooks'
import type {ActionFunction} from 'components/types'
import styles from './index.scss'

export type RenderButtonProps = {
  toggle: ActionFunction,
  ...
}

type Props = $ReadOnly<{
  renderButton: (RenderButtonProps) => Node,
  renderChildren: ?({toggle: () => void}) => Node,
  title: ?string | ?Node,
  sectionName: string,
  className?: string,
  popoverClassName?: string,
}>

function DropdownSection({
  renderButton,
  renderChildren,
  title,
  sectionName,
  className,
  popoverClassName,
}: Props): Element<"div"> {
  const [isOpen, {toggle: toggleSection}] = useToggle()

  const maybeRenderChildren = () => (
    renderChildren && renderChildren({toggle: toggleSection})
  )

  const popoverClass = classNames(styles.popover, popoverClassName)

  return (
    <div id={`sidebar_section_${sectionName}`} className={className}>
      {renderButton({
        toggle: toggleSection,
        isOpen,
      })}
      <ReactRelayContext.Consumer>
        {(value) => (
          <Popover
            popperClassName={popoverClass}
            innerClassName={styles.popoverInner}
            placement="auto"
            isOpen={isOpen}
            target={`sidebar_section_${sectionName}`}
            toggle={toggleSection}
            trigger="legacy"
            modifiers={[
              {name: 'flip', options: ['left', 'bottom', 'top']},
              {name: 'preventOverflow', options: {boundary: 'viewport'}},
            ]}
          >
            {title && title !== '' && (
              <PopoverHeader className={styles.popoverHeader}>
                {title}
              </PopoverHeader>
            )}
            <ReactRelayContext.Provider
              value={value}
            >
              <PopoverBody>
                {maybeRenderChildren()}
              </PopoverBody>
            </ReactRelayContext.Provider>
          </Popover>
        )}
      </ReactRelayContext.Consumer>
    </div>
  )
}

export default DropdownSection
